export default class commonConstant {
    // Time setting
    static VN_TIME_ZONE = "Asia/Bangkok";
    static US_LOCALE = "en-US";
    static FORMAT_DATE_YMD_HMS = "YYYY-MM-DD HH:mm:ss";
    static FORMAT_ISO_DATE_YMD_HMS = "YYYY-MM-DD[T]HH:mm:ss";
    static FORMAT_DATE_YMD = "YYYY-MM-DD";
    static FORMAT_DATE_HMS = "HH:mm:ss";
    static FORMAT_DATE_TIMEZONE = "hh:mm A , D MMM YYYY ([GMT]Z)";
    static FORMAT_DATE_TIME_HMA_DMY = "hh:mm A, DD MMM YYYY";
    static FORMAT_DATE_WEEKDAY = "dddd, D MMM, YYYY";
}
